<template>
  <div class="filter-bar ui basic segment grid">
    <div class="ui form">
      <div class="inline field">
        <h6 class="heading-small text-muted mb-4">Search</h6>
        <div class="input-group mb-3">
          <input type="text" class="form-control autocomplete-custom" :placeholder="placeholder" @keyup.enter="doFilter"
            v-model="filterText">
          <div class="input-group-append">
            <base-dropdown v-model="searchFilter">
              <base-button slot="title" type="secondary"
                class="btn-outline-primary dropdown-toggle dropdown-toggle-split"
                style="border-top-left-radius: 0px;border-bottom-left-radius: 0px;" />
              <a class="dropdown-item" @click.prevent="changeSearchFilter('cashier_name')">Cashier Name</a>
              </base-dropdown>
          </div>
        </div>

        <base-input alternative="" label="Date"><br>
          <a-range-picker v-model="inputDate" format="MM/DD/YYYY" :placeholder="['Start Time', 'End Time']" style="width:100%" 
            :filterOption="filterOption" @change="doFilter()"/>
        </base-input>
        <base-input label="Activity">
          <select class="form-control" v-model="activity" @change="doFilter()" size="large">
            <option v-for="option in activityOptions" :value="option.value" v-bind:key="option.key">
              {{ option.value }}
            </option>
          </select>
        </base-input>
        <base-input label="Site"><br>
          <a-select v-model="site_id" showSearch placeholder="Search by site" @change="filterTerminal" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
          </a-select>
        </base-input>

        <base-input label="Terminal"><br>
          <a-select v-model="terminal_id" showSearch placeholder="Search by terminal" @change="doFilter" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
            <a-select-option v-for="option in terminalOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
          </a-select>
        </base-input>

      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import HTTPRequest from '../controllers/httpRequest.js'
  import secureStorage from '../controllers/secureStorage.js'
  import moment from 'moment'
  import { filter } from 'jszip'
  var component_x;
  export default {
    computed: {
      ...mapState(['currentProfile']),
    },
    data: function () {
      return {
        filterText: '',
        searchFilter: "cashier_name",
        placeholder: "Search by cashier name",
        filterStatus: '0',
        inputDate: [moment().startOf('day'), moment().endOf('day')], 
        activity: "ALL",
        activityOptions: [
          {value: "ALL", key: ""},
          {value: "Merge Table", key: "MTB"},
          {value: "Transfer Table", key: "TTB"},
          {value: "Split Table", key: "STB"},
          {value: "Split Check", key: "SCHK"},
          {value: "Void Line", key: "LVD"},
          {value: "Cancel (Clear All Items)", key: "CNL"},
          {value: "Void Transaction", key: "TVT"},
          {value: "Refund (Void Transaction After Payment)", key: "RFD"},
          {value: "Unsettled Transaction", key: "UST"},
          {value: "Exceed Supercard Discount", key: "ESDIS"},
          {value: "Exceed SC/PWD Discount", key: "EDIS"},
          {value: "Open Department", key: "OPD"},
          {value: "Price Override", key: "OVR"},
          {value: "Deposit", key: "FLT"},
          {value: "Withdrawal", key: "WIT"},
          {value: "Reprint", key: "RPN"},
          {value: "Reprint X Reading", key: "RXR"},
          {value: "Reprint Z Reading", key: "RZR"},
        ],
        site_id: 0,
        terminal_id: 0,
        site_type: "ho",
        terminalOptions: [],
        siteOptions: [],
      }
    },
    watch: {
      filterStatus: function () {
        this.doFilter()
        this.$emit('changeFilter', this.filterStatus, this.searchFilter, filterText)
      },
      currentProfile: function () {
          this.placeholder = 'Search by name'
          this.searchFilter = "cashier_name"
      },
    },
    computed: {
      ...mapState(['currentProfile','currentApiURL', 'endPoint']),
    },
    mounted: async function(){
      component_x = this;

      var siteId = secureStorage.getItem("defaultSiteId")
      let userId = secureStorage.getItem("userId")

      var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
      component_x.siteOptions = sites;
      component_x.siteOptions.push({id: 0, name: ' All Sites'})
      component_x.sort(component_x.siteOptions);
      component_x.site_id = siteId;

      let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
      if(site != undefined){
        this.site_type = site.site_type
      }

      let terminals;
      terminals = await HTTPRequest.getRequest(component_x.endPoint + "terminals/get_valid_terminals?site_id=" + siteId, null);
      component_x.terminalOptions = terminals;
      component_x.terminalOptions.push({id: 0, name: ' All Terminals'})
      component_x.sort(component_x.terminalOptions);
    },
    methods: {
      changeSearchFilter(searchFilter) {
        this.searchFilter = searchFilter
        if (searchFilter == "activity") {
          this.placeholder = "Search by activity"
        } else {
          this.placeholder = "Search by " + searchFilter
        }
      },
      doFilter() {
        let add_site = ""
        let add_terminal = ""
        let add_activity = ""
        let add_from_date = ""
        let add_to_date = ""
        let filterText = this.filterText

        if(this.inputDate != null && this.inputDate.length != 0){
          add_from_date = '&date_from=' + this.inputDate[0].format('YYYY-MM-DD HH:mm:ss')
          add_to_date = '&date_to=' + this.inputDate[1].format('YYYY-MM-DD HH:mm:ss')
        }

        if(this.site_id == 0){
          add_site = "&site_id=" + 0
        }
        if(this.site_id != 0){
          add_site = "&site_id=" + this.site_id
        }
        if(this.terminal_id != 0){
          add_terminal = "&terminal_id=" + this.terminal_id
        }
        if(this.activity != ""){
          if(this.activity == "ALL"){
            this.activity = ""
          } else {
            add_activity = "&activity=" + this.activity
          }
        }
        filterText = filterText + add_site + add_terminal + add_activity + add_from_date + add_to_date
        this.$emit('changeFilter', this.filterStatus, this.searchFilter, filterText)
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        },
        sort(data){
        data.sort(function (a, b) {
            return a.name.localeCompare(b.name);
        });
      },
      filterTerminal: async function(){
        component_x = this
        let terminals = await HTTPRequest.getRequest(component_x.endPoint + "terminals/get_valid_terminals?site_id=" + component_x.site_id, null);
        component_x.terminalOptions = terminals;
        component_x.terminalOptions.push({id: 0, name: ' All Terminals'})
        component_x.sort(component_x.terminalOptions);
        component_x.terminal_id = 0
        this.doFilter()
      },
      sort(data){
        data.sort(function (a, b) {
            return a.name.localeCompare(b.name);
        });
      },
      
    }
  }
</script>

<style>
  .autocomplete-custom {
      height: 43px !important;
  }
</style>
